import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-management',
  templateUrl: './event-management.component.html',
  styleUrls: ['./event-management.component.css']
})
export class EventManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
